module.exports = __webpack_public_path__ + "static/img/雪票.7d9a78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration/产品详情-雪票详情/雪票.png
// module id = thH/
// module chunks = 31